import React from 'react'
import AllComponents from './components/AllComponents';
import Footer from './components/Footer';
import DetailsHeading from './DedailsPage/DetailsHeading';
import SingleProperty from './DedailsPage/SingleProperty';
import BestDeal from './Home/BestDeal';
import { CartProvider } from 'react-use-cart';

function Details() {
  return (
    <CartProvider>
      <AllComponents />
      <DetailsHeading />
      <SingleProperty />
      <BestDeal />
      <Footer />
    </CartProvider>
  )
}

export default Details;